import React, { useState } from 'react';

const PREREQ_LABELS = {
  cco: 'Prerequisite: CCO',
  pentest: 'Prerequisite: Second Pentest',
  insurance: 'Prerequisite: Insurance'
};

export default function ActionCard({ card }) {
  const [expanded, setExpanded] = useState(true);
  const [showDraft, setShowDraft] = useState(false);

  return (
    <div className={`action-card priority-${card.priority}`}>
      <div className="card-header">
        <h3>{card.title}</h3>
        <span className={`card-badge ${card.priority}`}>{card.priority}</span>
      </div>

      {card.prerequisite && PREREQ_LABELS[card.prerequisite] && (
        <div className="card-prereq">{PREREQ_LABELS[card.prerequisite]}</div>
      )}

      <div className="card-summary">{card.summary}</div>

      {card.steps && card.steps.length > 0 && (
        <>
          <button className="card-toggle" onClick={() => setExpanded(!expanded)}>
            {expanded ? 'Hide steps' : `Show ${card.steps.length} steps`}
          </button>
          {expanded && (
            <ol className="card-steps">
              {card.steps.map((step, i) => (
                <li key={i}>{step}</li>
              ))}
            </ol>
          )}
        </>
      )}

      {card.draftContent && (
        <>
          <button className="card-toggle" onClick={() => setShowDraft(!showDraft)} style={{ marginTop: 8 }}>
            {showDraft ? 'Hide draft' : 'Show draft message'}
          </button>
          {showDraft && (
            <div className="card-draft">
              <div className="card-draft-label">Draft Message</div>
              {card.draftContent}
            </div>
          )}
        </>
      )}
    </div>
  );
}
